/* 🤖 this file was generated by svg-to-ts */
export const matIconRoomService: {
  name: 'room-service';
  data: string;
} = {
  name: 'room-service',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18.98 17H2v2h20v-2zM21 16c-.27-4.07-3.25-7.4-7.16-8.21A2.006 2.006 0 0 0 12 5a2.006 2.006 0 0 0-1.84 2.79C6.25 8.6 3.27 11.93 3 16h18zm-9-6.42c2.95 0 5.47 1.83 6.5 4.41h-13A7.002 7.002 0 0 1 12 9.58z"/></svg>`
};
